import { render } from "./TransactionComponent.vue?vue&type=template&id=72fdf0a8&scoped=true"
import script from "./TransactionComponent.vue?vue&type=script&lang=js"
export * from "./TransactionComponent.vue?vue&type=script&lang=js"

import "./TransactionComponent.vue?vue&type=style&index=0&id=72fdf0a8&lang=css"
import "./TransactionComponent.vue?vue&type=style&index=1&id=72fdf0a8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72fdf0a8"]])

export default __exports__